import type { SVGProps } from "react";
export interface SteakIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function SteakIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: SteakIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M7.602 3.088c4.66-3.502 10.095-2.62 13.157 1.053 3.047 3.656 3.085 8.105.492 11.158-.821.968-1.644 1.59-2.504 1.951-.863.363-1.677.427-2.412.406-.36-.01-.714-.042-1.035-.07-.332-.03-.632-.056-.935-.068-.59-.021-1.146.02-1.731.22-1.507.515-2.174 1.575-3.37 2.785-.56.564-1.256 1.155-2.204 1.435-.97.287-2.042.206-3.283-.253-1.707-.631-2.542-2.08-2.803-3.691-.255-1.572 0-3.409.523-5.198 1.039-3.562 3.28-7.421 5.657-9.375zm11.429 2.493c-2.329-2.793-6.599-3.565-10.448-.4-1.925 1.582-3.971 4.992-4.926 8.265-.475 1.628-.643 3.099-.463 4.207.174 1.069.633 1.671 1.363 1.941.92.34 1.483.32 1.864.207.403-.12.775-.389 1.243-.862.855-.864 2.079-2.591 4.243-3.33l.346-.108c.798-.222 1.533-.255 2.196-.231.37.014.73.046 1.05.075.33.029.619.054.9.063.55.015 1.014-.037 1.476-.232.464-.195 1.012-.57 1.661-1.334 1.791-2.11 1.937-5.33-.505-8.26Z"
      />
      <path
        fill={color}
        d="M9.684 5.903c1.537-1.165 3.12-1.632 4.598-1.51 1.564.128 2.89.909 3.79 1.989l.36.464c.785 1.086 1.164 2.18 1.19 3.223a4.4 4.4 0 0 1-.81 2.67l-.228.293c-.344.406-.742.746-1.263.944-.507.192-1.016.203-1.495.165-1.43-.113-2.635-.163-3.818.135l-.506.15c-1.873.64-3.262 2.013-4.079 2.913l-.314.354a4 4 0 0 1-.528.536c-.075.06-.184.14-.32.206a1.35 1.35 0 0 1-.666.136 1.23 1.23 0 0 1-.895-.474 1.4 1.4 0 0 1-.244-.51l-.028-.134c-.138-.851-.02-2.12.43-3.658l.184-.593a20 20 0 0 1 1.787-3.883c.782-1.31 1.683-2.464 2.547-3.175zm4.413.732c-.84-.069-1.89.177-3.057 1.062l-.234.186c-.585.481-1.33 1.392-2.045 2.59a17.8 17.8 0 0 0-1.582 3.435l-.163.517-.052.19c.946-.85 2.23-1.778 3.811-2.318l.343-.109c1.708-.504 3.35-.41 4.885-.29.332.027.46-.003.522-.026.048-.018.15-.068.344-.296l.111-.142c.247-.346.406-.79.393-1.308-.013-.517-.2-1.183-.765-1.963l-.265-.341a3.27 3.27 0 0 0-2.246-1.187M13.8 8.93a.62.62 0 0 0-.125.37l.012.127c.019.09.06.172.113.244zm1 .741a.6.6 0 0 0 .112-.244l.013-.126-.013-.126a.6.6 0 0 0-.112-.245zm1.125-.37a1.625 1.625 0 0 1-3.241.167l-.009-.167.009-.166a1.625 1.625 0 0 1 1.616-1.46l.166.009c.82.083 1.46.775 1.46 1.616Z"
      />
    </svg>
  );
}
